import {GetRefundProcedures} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteGetRefundProcedures} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetRefundEligibleProcedures = (): GetRefundProcedures =>
	new RemoteGetRefundProcedures(
		makeBFFApiUrl(RefundFlowEndPoints.listEligibleProcedures),
		makeAuthorizeHttpClientDecorator(),
	);
